import { AuthenticationError, AuthorizationError, BusinessConstraintViolationError, IllegalArgumentError, ResourceAlreadyExistsError, ResourceNotFoundError, UnknownError, } from '../sdk/errors';
import { DataServiceApiError, NetworkError } from './data-service-api';
import { DialectCloudUnreachableError } from '../internal/errors';
export async function withErrorParsing(promise, onResourceAlreadyExists = (e) => new ResourceAlreadyExistsError(createMessage(e))) {
    try {
        return await promise;
    }
    catch (e) {
        if (e instanceof NetworkError) {
            throw new DialectCloudUnreachableError([e]);
        }
        if (e instanceof DataServiceApiError) {
            if (e.statusCode === 400) {
                console.error(e);
                throw new IllegalArgumentError(createMessage(e));
            }
            if (e.statusCode === 401) {
                throw new AuthenticationError(createMessage(e));
            }
            if (e.statusCode === 403) {
                throw new AuthorizationError(createMessage(e));
            }
            if (e.statusCode === 404) {
                throw new ResourceNotFoundError(createMessage(e));
            }
            if (e.statusCode === 409) {
                throw onResourceAlreadyExists(e);
            }
            if (e.statusCode === 422) {
                throw new BusinessConstraintViolationError(createMessage(e));
            }
            throw new UnknownError([e], createMessage(e));
        }
        throw new UnknownError([e]);
    }
}
function createMessage(e) {
    var _a;
    return `${(_a = e.message) !== null && _a !== void 0 ? _a : e.error}. ${e.requestId ? `Request ID: ${e.requestId}` : ''}`;
}
//# sourceMappingURL=data-service-errors.js.map